import { render, staticRenderFns } from "./VerifyEmailLender-Desktop.vue?vue&type=template&id=6d0b96f6&scoped=true"
import script from "./VerifyEmailLender-Desktop.vue?vue&type=script&lang=js"
export * from "./VerifyEmailLender-Desktop.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailLender-Desktop.vue?vue&type=style&index=0&id=6d0b96f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b96f6",
  null
  
)

export default component.exports